import {Component, Input, OnInit} from '@angular/core';
import {DecisionsService} from "../../decisions.service";
import {ViewManagerService} from "../../../../services/view-manager.service";
import {ChannelDefinition} from "../../../../model/channels.model";
import {ModelEvaluation} from "../../../../model/decisions.model";

@Component({
  selector: 'admin-decisions-model-data',
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.css']
})
export class DataComponent implements OnInit {

  @Input() channel: ChannelDefinition = new ChannelDefinition();

  private engineEvaluations: ModelEvaluation[]
  private decisionEvaluations: ModelEvaluation[]

  constructor(
    private service: DecisionsService,
    private viewManager: ViewManagerService
  ) {
  }

  ngOnInit(): void {
    this.service.data(this.channel.config!, "engine")
      .pipe()
      .subscribe({
        next: (result) => {
          this.engineEvaluations = result;
        },
        error: error => {
          console.log(error);
        }
      });

    this.service.data(this.channel.config!, "decision")
      .pipe()
      .subscribe({
        next: (result) => {
          this.decisionEvaluations = result;
        },
        error: error => {
          console.log(error);
        }
      });
  }

  getEngineEvaluations() {
    return this.engineEvaluations;
  }

  getDecisionEvaluations() {
    return this.decisionEvaluations;
  }
}
